import { render, staticRenderFns } from "./SelectOptions.vue?vue&type=template&id=2b0a142a&scoped=true&"
import script from "./SelectOptions.vue?vue&type=script&lang=js&"
export * from "./SelectOptions.vue?vue&type=script&lang=js&"
import style0 from "./SelectOptions.vue?vue&type=style&index=0&id=2b0a142a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a142a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
